import Icon from '@/components/ui/AppIcon';

interface StatsCardProps {
  icon: string
  value: string
  label: string
  delay?: number
}

export default function StatsCard({ icon, value, label, delay = 0 }: StatsCardProps) {
  return (
    <div 
      className="p-8 border-b border-border flex flex-col justify-between min-h-[200px] group hover:bg-card transition-all duration-500 reveal"
      style={{ transitionDelay: `${delay}ms` }}
    >
      <Icon 
        name={icon as any}
        size={40}
        className="text-muted-foreground group-hover:text-primary transition-colors duration-500"
      />
      <div>
        <h2 className="text-5xl font-bold tracking-tight text-foreground mb-2">{value}</h2>
        <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground">
          {label}
        </span>
      </div>
    </div>
  )
}